import script from "./kfInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./kfInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./kfInfoAdd.vue?vue&type=style&index=0&id=5ab1a6e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab1a6e3"]])

export default __exports__